(function () {
    'use strict';

    angular
        .module('tikonApp')
        .provider('AlertToastService', AlertToastService);

    function AlertToastService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$translate', '$injector'];

        function getService($timeout, $translate, $injector) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 3000; // default timeout


            return {
                success: success,
                error: error
            };


            function showToast(msg, type, params, position) {
                var mdToast = $injector.get('$mdToast');

                if (type == '' || type == null)
                    type = 'success';

                mdToast.show(
                    mdToast.simple()
                        .content(msg)
                        .hideDelay(timeout)
                        .theme(type + '-toast'));

            }

            function success(msg, params, position) {
                $translate(msg).then(function (m) {
                    showToast(m, 'success', params, position);
                });
            }

            function error(msg, params, position) {
                $translate(msg).then(function (m) {
                    showToast(m, 'error', params, position);
                });
            }


        }


    }
})();
